import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    this.element.classList.toggle("drawer--open");
    if (this.element.classList.contains("drawer--open")) {
      this.element.focus();
    }
  }
  openList() {
    this.element.classList.add("drawer--open");
    this.element.focus();
  }
  close() {
    this.element.classList.remove("drawer--open");
  }
  openFilters() {
    // Placeholder: show filters modal or drawer
    alert("Filters coming soon!");
  }
} 